// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9hAgc","left":"styles_left__3atvU"};